/**
 * The order a dropdown's options are shown in on the member screens.
 *
 * A-Z by label is the default (Maui LTRG asked for A-Z dropdowns). A list whose
 * every option carries a numeric `order` keeps that order instead, for lists
 * whose order means something: IFR's ECM status reads PE, OU, EN, EX, SFHP's
 * progression, where A-Z would give EN, EX, OU, PE.
 */
export interface OrderableOption {
  label: string;
  order?: number | null;
}

export function orderOptions<T extends OrderableOption>(options: readonly T[] | null | undefined): T[] {
  const list = [...(options || [])];
  if (list.length > 0 && list.every((o) => typeof o.order === 'number' && Number.isFinite(o.order))) {
    return list.sort((a, b) => (a.order as number) - (b.order as number));
  }
  return list.sort((a, b) => a.label.localeCompare(b.label));
}
